import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-46a8ecd0")

_pushScopeId("data-v-46a8ecd0")
const _hoisted_1 = { class: "content" }
const _hoisted_2 = { class: "pages" }
const _hoisted_3 = { class: "preview" }
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache) {
  const _component_ContentItem = _resolveComponent("ContentItem")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("button", {
        onClick: _cache[1] || (_cache[1] = $event => (_ctx.prev($event)))
      }, "Prev"),
      _createVNode("button", {
        onClick: _cache[2] || (_cache[2] = $event => (_ctx.next($event)))
      }, "Next")
    ]),
    _createVNode("div", _hoisted_3, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.particles, (particle, index) => {
        return (_openBlock(), _createBlock(_component_ContentItem, {
          key: index,
          id: particle.id,
          dict: particle.dict,
          asset: particle.asset
        }, null, 8 /* PROPS */, ["id", "dict", "asset"]))
      }), 128 /* KEYED_FRAGMENT */))
    ])
  ]))
})